/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     全局过滤器 filter.js
  | @Version:   2018-12-10  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/

/**
 * parseTime: 时间戳转时间字符
 * formatTime: 时间格式化
 */
export { parseTime, formatTime, byteSize } from '@/utils/common'

function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * timeAgo: 时间戳计算流逝时间
 * @param {int} time
 * @return {String}
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/**
 * numberFormatter: 数字格式化，并保留小数位数
 * @param {int} num
 * @param {int} digits
 * @return {String}
 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

/**
 * toThousandFilter: 数字格式化，三位形式
 * @param {int} num
 * @return {String}
 */
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

/**
 * currency: 货币格式化，并默认保留小数位数
 * @param { float, string} numberOrString
 * @param {int} digits
 * @return {String}
 */
export function currency(numberOrString, digits = 2) {
  if (numberOrString === undefined) {
    return ''
  } else {
    return '￥' + (+numberOrString % 1 == 0 ? +parseFloat(numberOrString).toFixed(digits) : parseFloat(numberOrString).toFixed(digits))
  }
}

export function numCurrency(numberOrString, digits = 2) {
  if (numberOrString === undefined) {
    return ''
  } else {
    return parseFloat(numberOrString).toFixed(digits)
  }
}
